import * as React from 'react';
import {
  createStyles,
  withStyles,
  WithStyles,
  Theme,
} from '@material-ui/core/styles';

import AppBar from 'ha/ui/next/AppBar';
import Toolbar from 'ha/ui/next/Toolbar';
import Grid from 'ha/ui/next/Grid';
import NoSSR from 'ha/components/NoSSR';

import MobileDrawer from '../containers/MobileDrawer';
import ListYourPlaceCTA from '../containers/ListYourPlaceCTA';
import NavBarLogo from './NavBarLogo';
import AuthenticatedNavigationMobile from '../containers/AuthenticatedNavigationMobile.lazy';
import UnauthenticatedNavigationMobile from '../containers/UnauthenticatedNavigationMobile';

const styles = (theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 1,
      marginRight: '-12px',
    },
    appBar: {
      backgroundColor: '#fff',
    },
    toolbar: {
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
    },
    breadcrumbs: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      paddingRight: theme.spacing.unit * 2,
      paddingLeft: theme.spacing.unit * 2,
    },
  });

interface Props extends WithStyles<typeof styles> {
  breadcrumbs?: React.ReactElement<{ withoutFirstSeparator: boolean }> | null;
  isAuthenticated: boolean;
  isCTAVisible: boolean;
}

export const NavBarMobile: React.SFC<Props> = ({
  classes,
  breadcrumbs,
  isAuthenticated,
  isCTAVisible,
}) => (
  <AppBar position="static" className={classes.appBar}>
    <Toolbar className={classes.toolbar}>
      <Grid spacing={8} alignItems="center" container>
        <Grid item>
          <NavBarLogo />
        </Grid>

        {/* Empty space that fills up available space */}
        <div className={classes.grow} />

        {isAuthenticated && <AuthenticatedNavigationMobile />}

        {isCTAVisible && (
          <Grid item>
            <ListYourPlaceCTA isAuthenticated={isAuthenticated} isMobile />
          </Grid>
        )}

        {!isAuthenticated && <UnauthenticatedNavigationMobile />}
      </Grid>
    </Toolbar>

    <NoSSR>
      <MobileDrawer />
    </NoSSR>

    {breadcrumbs && (
      <div className={classes.breadcrumbs}>
        {React.cloneElement(breadcrumbs, {
          withoutFirstSeparator: true,
        })}
      </div>
    )}
  </AppBar>
);

export default withStyles(styles)(NavBarMobile);
